import apiClient from './api';

const notificationService = {
  // Get all notifications for the current user
  getNotifications: async (params) => {
    const response = await apiClient.get('/notifications/', { params });
    return response.data;
  },

  // Get unread notification count
  getUnreadCount: async () => {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data;
  },

  // Get a specific notification
  getNotification: async (id) => {
    const response = await apiClient.get(`/notifications/${id}`);
    return response.data;
  },

  // Mark a notification as read
  markAsRead: async (id) => {
    const response = await apiClient.put(`/notifications/${id}/read`);
    return response.data;
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    const response = await apiClient.put('/notifications/mark-all-read');
    return response.data;
  },

  // Delete a notification
  deleteNotification: async (id) => {
    const response = await apiClient.delete(`/notifications/${id}`);
    return response.data;
  },

  // Clear all read notifications
  clearAllNotifications: async () => {
    const response = await apiClient.delete('/notifications/clear-all');
    return response.data;
  },

  // Reset employee password (admin action)
  resetEmployeePassword: async (employeeUsername, newPassword) => {
    const response = await apiClient.post('/auth/reset-employee-password', {
      employee_username: employeeUsername,
      new_password: newPassword,
    });
    return response.data;
  },
};

export default notificationService;
